/* Change header market links */
(function(){
  function rewriteLinksIn(container, anchorSelector){
    if(!container) return;
    var links = container.querySelectorAll(anchorSelector);
    if(!links.length) return;
    var p = window.location.pathname, s = window.location.search, h = window.location.hash;
    links.forEach(function(a){
      try{
        var u = new URL(a.getAttribute('href'), a.baseURI || window.location.origin);
        u.pathname = p; u.search = s; u.hash = h;
        a.setAttribute('href', u.toString());
      }catch(_){}
    });
  }

  function updateDropdown(comp){
    if(!comp) return;
    rewriteLinksIn(comp.querySelector('#dropdown-country-'), 'a.localization-item');
    if(comp.shadowRoot) rewriteLinksIn(comp.shadowRoot.querySelector('#dropdown-country-'), 'a.localization-item');
  }

  function updateDrawer(comp){
    if(!comp) return;
    rewriteLinksIn(comp, '.menu-drawer__menu a[href]');
  }

  function updateAll(){
    document.querySelectorAll('dropdown-localization-component').forEach(updateDropdown);
    document.querySelectorAll('drawer-localization-component').forEach(updateDrawer);
  }

  var t;
  function debounceUpdate(){ clearTimeout(t); t = setTimeout(updateAll, 50); }

  function wireComponentObservers(){
    document.querySelectorAll('dropdown-localization-component').forEach(function(comp){
      if(comp.__wired) return; comp.__wired = true;
      var mo = new MutationObserver(debounceUpdate);
      mo.observe(comp, {subtree:true,childList:true,attributes:true,attributeFilter:['aria-expanded','hidden','open']});
      comp.addEventListener('click', debounceUpdate, true);
    });
    document.querySelectorAll('drawer-localization-component').forEach(function(comp){
      if(comp.__wired) return; comp.__wired = true;
      var mo = new MutationObserver(debounceUpdate);
      mo.observe(comp, {subtree:true,childList:true,attributes:true,attributeFilter:['open','hidden','aria-expanded']});
      comp.addEventListener('toggle', debounceUpdate, true);
      comp.addEventListener('click', debounceUpdate, true);
    });
  }

  function init(){
    updateAll();
    wireComponentObservers();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function(){ init(); });
  document.addEventListener('shopify:section:reorder', function(){ init(); });

  new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){
      var n = muts[i].target;
      if(n && (n.closest && (n.closest('dropdown-localization-component') || n.closest('drawer-localization-component')))){
        debounceUpdate();
        wireComponentObservers();
        break;
      }
    }
  }).observe(document.documentElement,{subtree:true,childList:true});
})();

/* Create a fake sale price on collection page */
(() => {
  const HANDLE = "training-program-yearly";
  const NEW_AMOUNT = "79.99";

  const card = document.querySelector(`product-card[data-product-handle="${HANDLE}"]`);
  if (!card) return;

  const priceContainers = card.querySelectorAll('div[ref="priceContainer"]');
  priceContainers.forEach((container) => {
    const priceMoneyEl = container.querySelector('.price > .money');
    if (!priceMoneyEl) return;

    const originalPrice = priceMoneyEl.textContent.trim();

    const updated = document.createElement('span');
    updated.setAttribute('role', 'group');
    updated.innerHTML =
      `<span class="price"><span class="money">€${NEW_AMOUNT}</span></span>`;

    const compare = document.createElement('span');
    compare.setAttribute('role', 'group');
    compare.innerHTML =
      `<span class="compare-at-price"><span class="money">${originalPrice}</span></span>`;

    container.innerHTML = "";
    container.appendChild(updated);
    container.appendChild(compare);
  });
})();

/* Add delivery date in product page */
const target = document.querySelector('.order-before-block p strong');

if (target) {
  const today = new Date();
  today.setDate(today.getDate() + 3);

  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();

  const formattedDate = `${dd}/${mm}/${yyyy}`;

  target.textContent = formattedDate;
}

/* Order tracking and returns */
const fproTrackingNumber = document.querySelector('.tracking-labels .tracking-number');
const fproZipCode = document.querySelector('.tracking-labels .zip-code');

if (fproTrackingNumber || fproZipCode) {
  const fproObserver = new MutationObserver(() => {
    const fproFirstInputPage = document.querySelector('#trackingPageDiv .inputElement:first-child');
    const fproSecondInputPage = document.querySelector('#trackingPageDiv .inputElement:nth-child(3)');
    const fproFirstInputHeader = document.querySelector('#returnFormHeader .inputElement:first-child');

    if (fproFirstInputPage && fproTrackingNumber) {
      fproFirstInputPage.parentNode.insertBefore(fproTrackingNumber, fproFirstInputPage);
    }

    if (fproSecondInputPage && fproZipCode) {
      fproSecondInputPage.parentNode.insertBefore(fproZipCode, fproSecondInputPage);
    }

    if (fproFirstInputHeader && fproTrackingNumber) {
      const fproClone = fproTrackingNumber.cloneNode(true);
      fproFirstInputHeader.parentNode.insertBefore(fproClone, fproFirstInputHeader);
    }

    if (
      (fproFirstInputPage && fproTrackingNumber) &&
      (fproSecondInputPage && fproZipCode) &&
      (fproFirstInputHeader)
    ) {
      fproObserver.disconnect();
    }
  });

  fproObserver.observe(document.body, { childList: true, subtree: true });
}

/* Cart upsells - shared form, price sync, and add-to-cart logic */
(function(){
  if (window.__upsellsSharedInit) return;
  window.__upsellsSharedInit = true;

  var ROOT = '[data-fpro-ecupsells]';
  var FORM_SELECTOR = ROOT + ' .fpro-ecupsells__form';
  var SECTION_FALLBACK = ['cart-drawer','cart-drawer-items','cart-icon-bubble','cart-count-bubble','cart-notification','mini-cart'];

  var MONEY_FORMAT = window.FPRO_MONEY_FORMAT || '${{amount}}';
  var submitLocks = new WeakMap();
  var lastAddAbort = null;

  function norm(s){ return String(s==null?'':s).replace(/\s+/g,' ').trim(); }
  function dehtml(s){
    return (s||'')
      .replace(/&quot;/g,'"').replace(/&#34;/g,'"')
      .replace(/&apos;/g,"'").replace(/&#39;/g,"'")
      .replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&');
  }
  function parseJSONAttr(el,attr){ var raw=el.getAttribute(attr)||'[]'; try{ return JSON.parse(dehtml(raw)); }catch(_){ return []; } }

  function formatWithDelimiters(number, precision, thousands, decimal){
    precision = isNaN(precision = Math.abs(precision)) ? 2 : precision;
    thousands = (thousands===undefined) ? ',' : thousands;
    decimal   = (decimal===undefined)   ? '.' : decimal;
    var parts = (Number(number)/100).toFixed(precision).split('.');
    var integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var fraction = parts[1] ? (decimal + parts[1]) : '';
    return integer + fraction;
  }
  function formatMoney(cents, format){
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var fmt = format || MONEY_FORMAT;
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var key = (fmt.match(placeholderRegex) || [,'amount'])[1];
    var value;
    switch (key) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default: value = formatWithDelimiters(cents, 2); break;
    }
    return fmt.replace(placeholderRegex, value);
  }
  function fmtMoney(cents){
    try{ if(window.Shopify && typeof Shopify.formatMoney==='function'){ return Shopify.formatMoney(cents, MONEY_FORMAT); } }
    catch(e){}
    return formatMoney(cents, MONEY_FORMAT);
  }

  function drawerComponent(){ return document.querySelector('cart-drawer-component'); }
  function drawerDialog(){ var c=drawerComponent(); return c && (c.querySelector('dialog[ref="dialog"]') || c.querySelector('dialog')); }
  function openDrawer(){
    var opener=document.querySelector('[data-cart-open],[data-action="open-cart"],[aria-controls="cart-drawer"],cart-drawer-component [on\\:click="/open"]');
    if(opener){ try{ opener.click(); }catch(e){} }
    var dlg=drawerDialog();
    if(dlg && !dlg.open){
      try{ dlg.showModal ? dlg.showModal() : dlg.setAttribute('open',''); }catch(e){ dlg.setAttribute('open',''); }
    }
    document.documentElement.classList.add('js-drawer-open','cart-open');
    document.body.classList.add('js-drawer-open','cart-open');
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
  }

  function discoverSectionIds(){
    var ids=new Set();
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function(el){
      var id=el.getAttribute('data-section-id'); if(id) ids.add(id);
    });
    document.querySelectorAll('[data-section-id]').forEach(function(el){
      var id=el.getAttribute('data-section-id'); if(id && /cart|header|drawer|mini/i.test(id)) ids.add(id);
    });
    var arr = Array.from(ids);
    if(!arr.length) arr = SECTION_FALLBACK.slice();
    return arr;
  }

  function replaceSectionsByIdMap(htmlMap, ensureOpen){
    if(!htmlMap) return;
    var parser=new DOMParser();
    Object.keys(htmlMap).forEach(function(id){
      var html=htmlMap[id]; if(!html) return;
      var doc = parser.parseFromString(html,'text/html');
      var incoming = doc.getElementById('shopify-section-'+id) || doc.querySelector('[data-section-id="'+id+'"]');
      var current  = document.getElementById('shopify-section-'+id) || document.querySelector('[data-section-id="'+id+'"]');
      if(incoming && current){
        current.innerHTML = incoming.innerHTML;
        document.dispatchEvent(new CustomEvent('cart:sections:replaced'));
        document.dispatchEvent(new CustomEvent('shopify:section:load', { detail:{ sectionId:id } }));
      }
    });
    if(ensureOpen) openDrawer();
  }

  async function refreshCartSectionsWithRetries(openAfter, tries){
    var ids = discoverSectionIds();
    var params = new URLSearchParams();
    params.set('sections', ids.join(','));
    params.set('sections_url', window.location.pathname + window.location.search);
    try{
      var res = await fetch('/?'+params.toString(), {
        headers:{ 'Accept':'application/json', 'Cache-Control':'no-store' },
        credentials:'same-origin',
        cache:'no-store'
      });
      if(!res.ok) throw new Error('sections fetch '+res.status);
      var htmlMap = await res.json().catch(function(){ return null; });
      if(htmlMap) replaceSectionsByIdMap(htmlMap, openAfter);
      else if(tries>0) setTimeout(function(){ refreshCartSectionsWithRetries(openAfter, tries-1); }, 200);
    }catch(e){
      if(tries>0){ setTimeout(function(){ refreshCartSectionsWithRetries(openAfter, tries-1); }, 250); }
    }
  }

  function normalizeOpts(v){ return [v.option1,v.option2,v.option3].filter(function(x){return x!=null;}).map(String); }
  function selectedByIndex(form){
    var out=[]; form.querySelectorAll('.fpro-option').forEach(function(g){
      var i=+g.getAttribute('data-opt-index')||0;
      var sel=g.querySelector('.fpro-select');
      out[i]=sel ? norm(sel.value) : null;
    });
    return out;
  }
  function findVariant(form, variants){
    if(!variants||!variants.length) return null;
    var want=selectedByIndex(form);
    for(var i=0;i<variants.length;i++){
      var v=variants[i], opts=normalizeOpts(v).map(norm), ok=true;
      for(var j=0;j<want.length;j++){
        if(want[j]==null||want[j]==='') continue;
        if(opts[j]!==want[j]){ ok=false; break; }
      }
      if(ok) return v;
    }
    for(var k=0;k<variants.length;k++){ if(variants[k].available) return variants[k]; }
    return variants[0]||null;
  }
  function readPlanIdForVariant(form, vid){
    var el=(form.closest('.fpro-ecupsells__card')||form).querySelector('[data-plan-map][data-vid="'+ String(vid) +'"]');
    return el ? String(el.value||'') : '';
  }
  function firstVariantWithPlan(variants, form){
    for(var i=0;i<variants.length;i++){
      var v=variants[i]; var pid=readPlanIdForVariant(form,v.id);
      if(v.available && pid) return { v:v, planId:pid };
    }
    return null;
  }

  function parseMoneyInputToCents(str){
    str = (str || '').toString().trim();
    if(!str) return null;
    str = str.replace(/[^\d.,]/g,'');
    if(!str) return null;

    var lastDot = str.lastIndexOf('.');
    var lastComma = str.lastIndexOf(',');
    var decPos = Math.max(lastDot, lastComma);

    var intPart, decPart;
    if(decPos >= 0){
      intPart = str.slice(0, decPos).replace(/[^\d]/g,'');
      decPart = str.slice(decPos + 1).replace(/[^\d]/g,'');
    } else {
      intPart = str.replace(/[^\d]/g,'');
      decPart = '';
    }

    if(!intPart) intPart = '0';
    decPart = (decPart + '00').slice(0,2);
    return parseInt(intPart,10) * 100 + parseInt(decPart,10);
  }

  function isUpsell1Product(form){
    var root = form.closest('[data-fpro-ecupsells]');
    if(!root) return false;

    var upsell1 = (root.getAttribute('data-upsell-1-handle') || '');
    upsell1 = upsell1.replace(/\s+/g,'').toLowerCase();
    if(!upsell1) return false;

    var slide = form.closest('.fpro-ecupsells__slide');
    var handle = (slide && slide.getAttribute('data-product-handle')) || '';
    handle = handle.replace(/\s+/g,'').toLowerCase();
    return handle && handle === upsell1;
  }

  function readUpsell1SalePriceCents(form){
    var root = form.closest('[data-fpro-ecupsells]');
    if(!root) return null;
    var raw = root.getAttribute('data-upsell-1-sale-price') || '';
    return parseMoneyInputToCents(raw);
  }

  function applyPriceAndId(form, v){
    if(!v) return;
    var idInput=form.querySelector('input[name="id"]');
    if(idInput){ idInput.value=String(v.id); idInput.setAttribute('value', String(v.id)); }

    var wrap=(form.closest('.fpro-ecupsells__card')||form);
    var pw=wrap.querySelector('[data-price]');
    if(pw){
      var cur=pw.querySelector('[data-price-current]'), cmp=pw.querySelector('[data-price-compare]');
      var priceMap = parseJSONAttr(form,'data-variant-prices');
      var pre = priceMap && priceMap[String(v.id)];
      if(cur) cur.innerHTML = (pre && pre.price) ? pre.price : fmtMoney(v.price);
      if(cmp){
        if(v.compare_at_price && v.compare_at_price>v.price){
          cmp.hidden=false;
          var s=cmp.querySelector('s');
          var cap=(pre && pre.compare_at_price) ? pre.compare_at_price : fmtMoney(v.compare_at_price);
          if(s) s.innerHTML=cap; else cmp.innerHTML=cap;
          pw.classList.add('is-on-sale');
        }else{
          cmp.hidden=true; pw.classList.remove('is-on-sale');
        }
      }

      if (isUpsell1Product(form)) {
        var sale = readUpsell1SalePriceCents(form);
        if (sale != null) {
          var salesRoot = form.closest('[data-fpro-ecupsells]');
          var saleFormatted = salesRoot && salesRoot.getAttribute('data-upsell-1-sale-price-formatted');
          if (cur) cur.innerHTML = saleFormatted || fmtMoney(sale);
          if (cmp) {
            if (v && v.price && v.price > sale) {
              cmp.hidden = false;
              var s2 = cmp.querySelector('s');
              var cap2 = (pre && pre.price) ? pre.price : fmtMoney(v.price);
              if (s2) s2.innerHTML = cap2; else cmp.innerHTML = cap2;
              pw.classList.add('is-on-sale');
            } else {
              cmp.hidden = true;
              pw.classList.remove('is-on-sale');
            }
          }
        }
      }
    }
  }

  async function fetchWithRetry(url, opts, retries){
    try{ return await fetch(url, opts); }
    catch(err){
      if(retries>0){ await new Promise(r=>setTimeout(r, 150)); return fetchWithRetry(url, opts, retries-1); }
      throw err;
    }
  }

  document.addEventListener('submit', function(e){
    var form=e.target;
    if(!form.matches || !form.matches(FORM_SELECTOR)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if(submitLocks.get(form)) return;
    submitLocks.set(form, true);

    try{ if(lastAddAbort) lastAddAbort.abort(); }catch(_){}
    var ac = new AbortController(); lastAddAbort = ac;

    var variants = parseJSONAttr(form,'data-variants');
    if(!variants || !variants.length){ console.warn('[Upsell] No variants json on form'); submitLocks.delete(form); return; }

    var vSel = findVariant(form, variants);
    if(!vSel){ console.warn('[Upsell] No matching variant'); submitLocks.delete(form); return; }

    var requiresPlan = ((form.querySelector('[data-requires-plan]')||{}).value||'')==='true';
    var planId = readPlanIdForVariant(form, vSel.id);

    if(requiresPlan && !planId){
      var best = firstVariantWithPlan(variants, form);
      if(!best){ console.warn('[Upsell] requires selling_plan but none found'); submitLocks.delete(form); return; }
      vSel=best.v; planId=best.planId;
      form.querySelectorAll('.fpro-option').forEach(function(g,i){
        var sel=g.querySelector('.fpro-select'); var val=vSel['option'+(i+1)];
        if(sel && val!=null){ sel.value=val; sel.dispatchEvent(new Event('change',{bubbles:true})); }
      });
    }

    applyPriceAndId(form, vSel);

    var fd = new FormData();
    fd.set('id', String(vSel.id));
    fd.set('quantity','1');
    if(planId) fd.set('selling_plan', String(planId));
    else if(requiresPlan){ submitLocks.delete(form); return; }

    var sectionIds = discoverSectionIds();
    if(sectionIds.length){
      fd.set('sections', sectionIds.join(','));
      fd.set('sections_url', window.location.pathname + window.location.search);
    }

    var btn = form.querySelector('button[type="submit"],[ref="addToCartButton"]');
    if(btn) btn.disabled = true;

    fetchWithRetry('/cart/add.js', {
      method:'POST',
      credentials:'same-origin',
      headers:{ 'Accept':'application/json', 'Cache-Control':'no-store' },
      cache:'no-store',
      body: fd,
      signal: ac.signal
    }, 2)
    .then(function(r){
      if(!r.ok){
        return r.clone().json().catch(()=>r.text()).then(function(msg){
          throw new Error((msg && (msg.description||msg.message||msg.errors)) || ('HTTP '+r.status));
        });
      }
      return r.json();
    })
    .then(function(payload){
      if(payload && payload.sections){
        replaceSectionsByIdMap(payload.sections, true);
      } else {
        refreshCartSectionsWithRetries(true, 3);
      }
      openDrawer();
      document.dispatchEvent(new CustomEvent('cart:updated'));
    })
    .catch(function(err){
      console.warn('[Upsell Add] Failed:', err && err.message ? err.message : err);
    })
    .finally(function(){
      if(btn) btn.disabled = false;
      submitLocks.delete(form);
    });

  }, true);

  function syncOnSelect(e){
    var sel = e.target;
    if(!sel.matches || !sel.matches(ROOT+' .fpro-select')) return;
    var form = sel.closest('.fpro-ecupsells__form');
    if(!form) return;
    var variants = parseJSONAttr(form,'data-variants');
    var v = findVariant(form, variants);
    if(v) applyPriceAndId(form, v);
  }
  document.addEventListener('change', syncOnSelect, true);
  document.addEventListener('input',  syncOnSelect, true);
})();

/* Cart upsells carousel */
(function(){
  if (window.__upsellSwiperInit) return; 
  window.__upsellSwiperInit = true;

  var ROOT='[data-fpro-ecupsells]';

  function haveSwiper(){ return !!window.Swiper; }

  function whenMeasurable(el, cb){
    var start = performance.now();
    (function tick(){
      var r = el && el.getClientRects && el.getClientRects()[0];
      if (r && r.width > 0) { cb(); return; }
      if (performance.now() - start > 2000) { cb(); return; }
      requestAnimationFrame(tick);
    })();
  }

  function rebindNavigation(root, inst){
    if(!inst) return;
    var prev=root.querySelector('.fpro-ecupsells__btn--prev');
    var next=root.querySelector('.fpro-ecupsells__btn--next');
    try{
      if(inst.navigation && inst.navigation.destroy) inst.navigation.destroy();
      inst.params.navigation = inst.params.navigation || {};
      inst.params.navigation.prevEl = prev;
      inst.params.navigation.nextEl = next;
      if(inst.navigation && inst.navigation.init){ inst.navigation.init(); inst.navigation.update(); }
    }catch(_){}
    [ [prev,'prev'], [next,'next'] ].forEach(function(pair){
      var btn=pair[0], dir=pair[1];
      if(!btn || btn.__boundNavFallback) return;
      btn.__boundNavFallback = true;
      if(!btn.getAttribute('type')) btn.setAttribute('type','button');
      btn.addEventListener('click', function(e){
        try{
          if(root.__upsellsSwiper){
            e.preventDefault(); e.stopPropagation();
            dir==='prev' ? root.__upsellsSwiper.slidePrev() : root.__upsellsSwiper.slideNext();
          }
        }catch(_){}
      }, true);
    });
  }

  function needsRebuild(inst, vp){
    if(!inst || !vp) return true;
    if(inst.el !== vp) return true;
    var currentWrapper = vp.querySelector('.swiper-wrapper');
    if(inst.wrapperEl && currentWrapper && inst.wrapperEl !== currentWrapper) return true;
    if(inst.wrapperEl && !vp.contains(inst.wrapperEl)) return true;
    return false;
  }

  function createInstance(root, vp){
    whenMeasurable(vp, function(){
      var inst = new Swiper(vp, {
        slidesPerView: 1.1,
        spaceBetween: 8,
        rewind: true,
        navigation: {
          prevEl: root.querySelector('.fpro-ecupsells__btn--prev'),
          nextEl: root.querySelector('.fpro-ecupsells__btn--next')
        },
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        watchOverflow: true
      });
      root.__upsellsSwiper = inst;

      requestAnimationFrame(function(){ try{ inst.update(); }catch(_){} });
      root.querySelectorAll('img[loading="lazy"]').forEach(function(img){
        img.addEventListener('load', function(){ try{ inst.update(); }catch(_){} }, { once:true });
      });

      rebindNavigation(root, inst);
    });
  }

  function initOne(root){
    if(!root) return;
    var vp=root.querySelector('.fpro-ecupsells__viewport');
    if(!vp) return;

    var inst = root.__upsellsSwiper;

    if (inst && needsRebuild(inst, vp)){
      try{ inst.destroy(true,true); }catch(_){}
      root.__upsellsSwiper = null;
      if(!haveSwiper()) return;
      createInstance(root, vp);
      return;
    }

    if (inst && typeof inst.update === 'function'){
      whenMeasurable(vp, function(){
        try{ inst.update(); }catch(_){}
        rebindNavigation(root, inst);
      });
      return;
    }

    if(!haveSwiper()) return;
    createInstance(root, vp);
  }

  function initAll(scope){
    (scope||document).querySelectorAll(ROOT).forEach(initOne);
  }

  var raf=null;
  function schedule(scope){
    if(raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function(){ initAll(scope||document); });
  }

  function waitForSwiper(scope){
    if(haveSwiper()){ schedule(scope||document); return; }
    var tries=0, i=setInterval(function(){
      if(haveSwiper()){ clearInterval(i); schedule(scope||document); }
      else if(++tries>120){ clearInterval(i); }
    },50);
  }

  if(document.readyState!=='loading') waitForSwiper(document);
  else document.addEventListener('DOMContentLoaded', function(){ waitForSwiper(document); });

  [
    'shopify:section:load',
    'cart:sections:replaced',
    'cart:updated',
    'line-item:removed',
    'cart:cleared',
    'cart-drawer:open'
  ].forEach(function(evt){
    document.addEventListener(evt, function(){ waitForSwiper(document); });
  });

  function attachDrawerObservers(){
    var dialog = document.querySelector('cart-drawer-component dialog[ref="dialog"], cart-drawer-component dialog');
    if(!dialog) return;
    if(dialog.__upsellMoAttached) return;
    dialog.__upsellMoAttached = true;
    var mo = new MutationObserver(function(){ schedule(dialog); });
    mo.observe(dialog, { childList:true, subtree:true, attributes:true, attributeFilter:['class'] });
    dialog.addEventListener('transitionend', function(){ schedule(dialog); }, true);
  }
  attachDrawerObservers();
  document.addEventListener('DOMContentLoaded', attachDrawerObservers);
  document.addEventListener('shopify:section:load', attachDrawerObservers);

  window.addEventListener('pageshow', function(){ waitForSwiper(document); });
})();

/* Cart upsells sale price */
(function(){
  if (window.__upsellSaleStableV3) return;
  window.__upsellSaleStableV3 = true;

  function applyForRoot(root){
    var sale = (root.getAttribute('data-upsell-1-sale-price')||'').trim();
    if (!sale) return;

    var saleFormatted = (root.getAttribute('data-upsell-1-sale-price-formatted')||'').trim() || sale;

    var upsellHandle = (root.getAttribute('data-upsell-1-handle')||'').trim().toLowerCase();
    if (!upsellHandle) return;

    var slide = null;
    root.querySelectorAll('.fpro-ecupsells__slide').forEach(function(s){
      var h = (s.getAttribute('data-product-handle')||'').trim().toLowerCase();
      if (!slide && h === upsellHandle) slide = s;
    });
    if (!slide) return;

    var wrap = slide.querySelector('.fpro-ecupsells__price');
    if (!wrap) return;

    var current = wrap.querySelector('.fpro-price--current');
    var compare = wrap.querySelector('.fpro-ecupsells__compare');
    if (!current || !compare) return;

    var moneySpan = current.querySelector('.money');
    var alreadyHasMoneySpan = /class\s*=\s*["']?[^"'>]*\bmoney\b/i.test(saleFormatted);
    var saleHtml = (moneySpan && !alreadyHasMoneySpan) ? '<span class="money">'+saleFormatted+'</span>' : saleFormatted;

    if (!slide.getAttribute('data-upsell-original-html')) {
      slide.setAttribute('data-upsell-original-html', current.innerHTML);
    }
    var originalHtml = slide.getAttribute('data-upsell-original-html') || current.innerHTML;

    if (!compare.innerHTML.trim()) {
      var isStruck = /^\s*<\s*s[\s>]/i.test(originalHtml);
      compare.hidden = false;
      compare.innerHTML = isStruck ? originalHtml : '<s>'+originalHtml+'</s>';
    } else {
      compare.hidden = false;
    }

    if (current.getAttribute('data-sale-price-set') !== '1') {
      current.innerHTML = saleHtml;
      current.setAttribute('data-sale-price-set', '1');
    }

    if (!wrap.__upsellPriceMO){
      var mo = new MutationObserver(function(){
        if (current.getAttribute('data-sale-price-set') !== '1') {
          current.innerHTML = saleHtml;
          current.setAttribute('data-sale-price-set', '1');
        }
      });
      mo.observe(wrap, { childList:true, subtree:true, characterData:true });
      wrap.__upsellPriceMO = mo;
    }
  }

  function runAll(){
    document.querySelectorAll('[data-fpro-ecupsells]').forEach(applyForRoot);
  }

  function queueRuns(){
    runAll();
    setTimeout(runAll, 0);
    setTimeout(runAll, 80);
    setTimeout(runAll, 200);
  }

  document.addEventListener('DOMContentLoaded', queueRuns);
  ['shopify:section:load','cart:sections:replaced','cart:updated','line-item:removed','cart:cleared','cart-drawer:open']
    .forEach(function(evt){ document.addEventListener(evt, queueRuns); });
  window.addEventListener('pageshow', queueRuns);
  document.addEventListener('transitionend', function(e){
    if (e.target.closest && e.target.closest('cart-drawer-component')) queueRuns();
  }, true);

  document.addEventListener('submit', function(e){
    if (e.target && e.target.closest && e.target.closest('[data-fpro-ecupsells] .fpro-ecupsells__form')){
      queueRuns();
    }
  }, true);
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-fpro-ecupsells] .fpro-ecupsells__atc');
    if (btn) queueRuns();
  }, true);
})();

/* Set menu drawer height */
function setMenuDrawerHeightOnce() {
  const announcementBar = document.querySelector('.announcement-bar');
  const headerSection = document.querySelector('.header-section');
  const menuDrawer = document.querySelector('.menu-drawer');

  if (!menuDrawer) return null;

  const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
  const headerHeight = headerSection ? headerSection.offsetHeight : 0;

  menuDrawer.style.height = `calc(100dvh - ${announcementHeight + headerHeight}px)`;
  return menuDrawer;
}

const menuDrawer = setMenuDrawerHeightOnce();

if (menuDrawer) {
  const attributeObserver = new MutationObserver(function() {
    if (!menuDrawer.style.height) {
      setMenuDrawerHeightOnce();
    }
  });
  attributeObserver.observe(menuDrawer, { attributes: true, attributeFilter: ['style'] });
} else {
  const headerContainer = document.querySelector('header') || document.querySelector('[data-header-drawer]')?.parentElement;

  if (headerContainer) {
    const insertObserver = new MutationObserver(function() {
      const drawer = setMenuDrawerHeightOnce();
      if (drawer) {
        insertObserver.disconnect();

        const attributeObserver = new MutationObserver(function() {
          if (!drawer.style.height) {
            setMenuDrawerHeightOnce();
          }
        });
        attributeObserver.observe(drawer, { attributes: true, attributeFilter: ['style'] });
      }
    });
    insertObserver.observe(headerContainer, { childList: true, subtree: true });
  }
}

/* Adjust Appstle discount design */
(function () {
  const SAVE_SELECTOR = '.appstle_membership_save';
  const FINAL_PRICE_SELECTOR = '.appstle_membership_final_price .money';
  const ORIGINAL_PRICE_SELECTOR = '.price[data-appstle-membership-price-modified="true"] .money';
  const PROCESSED_ATTR = 'data-percent-applied';

  function parseMoneyToNumber(text) {
    if (!text) return null;

    const cleaned = text.replace(/[^0-9.,]/g, '').trim();
    if (!cleaned) return null;

    const hasComma = cleaned.includes(',');
    const hasDot = cleaned.includes('.');
    let normalized = cleaned;

    if (hasComma && hasDot) {
      normalized =
        cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')
          ? cleaned.replace(/\./g, '').replace(',', '.')
          : cleaned.replace(/,/g, '');
    } else if (hasComma) {
      const decimalDigits = cleaned.split(',').pop().length;
      normalized = decimalDigits === 2 ? cleaned.replace(',', '.') : cleaned.replace(/,/g, '');
    }

    const value = parseFloat(normalized);
    return Number.isFinite(value) ? value : null;
  }

  function applyDiscountPercent(saveEl) {
    if (!(saveEl instanceof HTMLElement)) return;
    if (saveEl.getAttribute(PROCESSED_ATTR) === 'true') return;

    const priceContainer = saveEl.closest('[ref="priceContainer"]') || saveEl.closest('product-price') || saveEl.parentElement;
    if (!priceContainer) return;

    const finalPriceEl = priceContainer.querySelector(FINAL_PRICE_SELECTOR);
    const originalPriceEl = priceContainer.querySelector(ORIGINAL_PRICE_SELECTOR);
    const amountEl = saveEl.querySelector('.transcy-money.money');

    if (!finalPriceEl || !originalPriceEl || !amountEl) return;

    const finalPrice = parseMoneyToNumber(finalPriceEl.textContent);
    const originalPrice = parseMoneyToNumber(originalPriceEl.textContent);

    if (finalPrice === null || originalPrice === null || originalPrice <= finalPrice) return;

    const percent = Math.round(((originalPrice - finalPrice) / originalPrice) * 100);

    saveEl.textContent = `-${percent}%`;
    saveEl.setAttribute(PROCESSED_ATTR, 'true');
  }

  function scanForSaveElements(root) {
    root.querySelectorAll(SAVE_SELECTOR).forEach(applyDiscountPercent);
  }

  document.querySelectorAll('product-price').forEach((priceEl) => {
    scanForSaveElements(priceEl);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches(SAVE_SELECTOR)) {
            applyDiscountPercent(node);
          }

          scanForSaveElements(node);
        });
      }
    });

    observer.observe(priceEl, { childList: true, subtree: true });
  });
})();